// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarsCanvas_stars__S9u77"};